export default __webpack_public_path__ + "static/media/douglas-fir.de6cf107.jpeg";